import styled from 'styled-components'

const Row = styled('div')`
  display: flex;
  flex-direction: row;
`
Row.displayName = 'Row'
export default Row
